export default {
  APPLICATIONFORMPDF: null,
  APPLICATIONFORMDETAILS: {},
  APPLICATIONFORMIMAGES: [],
  APPLICATIONFORMPRINTLOCATION: {},
};
